import type { FrameTriggerConfig } from 'lib/clients/FrameTrigger';
import type { StepDocumentConfig } from 'lib/interfaces/StepsConfig';
import { isLowLightForDocument } from 'verify/lib/utils/document';
import type { LuminosityData } from 'verify/lib/utils/image';

export enum DocumentTriggerType {
  DetectedLowLight,
  None,
}

export interface DocumentTriggerParams {
  luminosityData: LuminosityData | null;
}

export const DETECT_INTERVAL = 100;

export const DOCUMENT_TRIGGER_CONFIGS: Array<
  FrameTriggerConfig<
    DocumentTriggerType,
    DocumentTriggerParams,
    StepDocumentConfig['localizations']['capture-page']
  >
> = [
  {
    type: DocumentTriggerType.DetectedLowLight,
    shouldShow: detectsLowLight,
    showAfterFrames: 3,
    hideAfterFrames: 10,
    getPrompt: ({ t }) => t('document-scanner.hint.detected-low-light'),
  },
  {
    type: DocumentTriggerType.None,
    shouldShow: () => true,
    showAfterFrames: 0,
    hideAfterFrames: 0,
    getPrompt: ({ t }) => t('document-scanner.hint.default'),
  },
];

export function detectsLowLight(params: DocumentTriggerParams): boolean {
  return isLowLightForDocument(params.luminosityData);
}
